import React from 'react';
import LectureClipsViewer from '../components/LectureClips/LectureClipsViewer';

/**
 * Page wrapper for the Lecture Clips viewer.
 * Mounted at /lecture-clips route in App.js.
 */
const LectureClipsPage = () => <LectureClipsViewer />;

export default LectureClipsPage;
